const Images = {
  home: require("./hero-image.jpg"),
  hero1:require("./hero-carousel/hero-carousel-1.jpg"),
  hero2:require("./hero-carousel/hero-carousel-2.jpg"),
  hero3:require("./hero-carousel/hero-carousel-3.jpg"),
  hero4:require("./hero-carousel/hero-carousel-4.jpg"),
  hero5:require("./hero-carousel/hero-carousel-5.jpg"),
  hero6:require("./hero-carousel/pexels-zukiman-mohamad-190417(1).jpg"),
  about:require("./about/about-2.jpg"),
  testimonialHome:require("./testimonial/Testimonials.jpg"),
  testimonialMain:require("./testimonial/Testimonial.jpg"),
  testimonial1:require("./testimonial/Testimonial_1.jpg"),
  testimonial2:require("./testimonial/Testimonial_2.jpg"),
  testimonial3:require("./testimonial/Testimonial_3.jpg"),
  testimonial4:require("./testimonial/Testimonial_4.jpg"),
  testimonial5:require("./testimonial/Testimonial_5.jpg"),
  serviceMain:require("./service/service1.jpg"),
  service1:require("./service/service-1.jpg"),
  service2:require("./service/service-2.jpg"),
  service3:require("./service/service-3.jpg"),
  service4:require("./service/service-4.jpg"),
  service:require("./service/service2.jpg"),
  whyUs3:require("./whyUs/whyUs3.jpg"),
  whyUs2:require("./whyUs/whyUs2.jpg"),
  inclusionHome:require("./inclusion/inclusion.jpg"),
  inclusionMain:require("./inclusion/inclusionMain.jpg"),
  inclusion1:require("./inclusion/inclusion-1.jpg"),
  inclusion2:require("./inclusion/inclusion-2.jpg"),
  inclusion3:require("./inclusion/inclusion-3.jpeg"),
  inclusion4:require("./inclusion/inclusion-4.png"),
  inclusion5:require("./inclusion/inclusion-5.png"),
  inclusion6:require("./inclusion/inclusion-6.png"),
  inclusion7:require("./inclusion/inclusion-7.jpg"),
  inclusion8:require("./inclusion/inclusion-8.jpg"),
  inclusion9:require("./inclusion/inclusion-9.jpg"),
  inclusion10:require("./inclusion/inclusion-10.jpg"),
  inclusion11:require("./inclusion/inclusion-11.jpg"),
  galleryImage:require("./gallery/images/gallery.jpg"),
  galleryImageMain:require("./projects/project-1.jpg"),
  houseImage1:require("./gallery/images/project-1.jpg"),
  houseImage2:require("./gallery/images/project-2.jpg"),
  houseImage3:require("./gallery/images/project-3.jpg"),
  houseImage4:require("./gallery/images/project-4.jpg"),
  houseImage5:require("./gallery/images/project-5.jpg"),
  houseImage6:require("./gallery/images/project-6.jpg"),
  houseImage7:require("./gallery/images/project-7.jpg"),
  videoMain:require("./gallery/images/video.jpg"),
  contactUs:require("./contactus.jpeg"),
  aboutHome:require("./about/about.jpg"),
  teamHero:require("./team/team.jpg"),
  teamMember:require("./team/profile-1.jpg"),
  faqHero:require("./footer/faqHero.jpg"),
  faqMain:require("./footer/faq.jpg"),
  termHero:require("./footer/heroTerm.jpg"),
  termMain:require("./footer/mainTerm.jpg"),
  privacyHero:require("./footer/privacyHero.jpg"),
  privacyMain:require("./footer/privacyMain.jpg"),
};

export default Images;
